export default function ({ route, store }) {
  if (route.name === 'knowledge-home') {
    store.dispatch('knowledgeModule/getKnowledgeRootsWithChildren');
  }
}
